// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-breadcrumbs-docs',
    templateUrl: './breadcrumbs.docs.generated.html',
})
export class UIBreadcrumbsDocs { }
